(() => {
  const section = document.querySelector('.shopify-section.site-header-container');
  if (!section || window.terjungHeaderScrollReady) return;
  window.terjungHeaderScrollReady = true;

  const root = document.documentElement;
  const mobile = window.matchMedia('(max-width: 989px)');
  const tolerance = 6;
  let lastY = window.scrollY;
  let ticking = false;

  const setHeight = () => root.style.setProperty('--tj-header-h', `${section.offsetHeight}px`);

  const isBusy = () =>
    document.body.classList.contains('sidebar-opened') ||
    section.querySelector('search-form.is-terjung-search-open') ||
    (section.contains(document.activeElement) && document.activeElement.matches('input, textarea'));

  const show = () => root.classList.remove('tj-header-hidden');

  const update = () => {
    ticking = false;
    const y = Math.max(window.scrollY, 0);

    if (!mobile.matches) {
      root.classList.remove('tj-header-hidden', 'tj-header-pinned');
      lastY = y;
      return;
    }

    const previous = section.previousElementSibling;
    const start = previous ? previous.offsetTop + previous.offsetHeight : 0;
    root.classList.toggle('tj-header-pinned', y > start);

    if (y <= start + section.offsetHeight) {
      show();
      lastY = y;
      return;
    }

    const delta = y - lastY;
    if (Math.abs(delta) < tolerance) return;

    if (delta > 0 && !isBusy()) {
      root.classList.add('tj-header-hidden');
    } else if (delta < 0) {
      show();
    }
    lastY = y;
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  };

  setHeight();
  if ('ResizeObserver' in window) new ResizeObserver(setHeight).observe(section);
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  section.addEventListener('focusin', show);
  update();
})();
